import { useEventCallback } from '@cian/react-utils';
import { useRef, useState, useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setOpenedFilter } from '../../../actions/filters';
import { TFilterKeys } from '../../../types/filters';
import { useMetaTooltip } from './useMetaTooltip';
import { selectOpenedFilter } from '../../../selectors/filters';

export const useDropdownFilter = (filterKey: TFilterKeys) => {
  const filterRef = useRef(null);

  const dispatch = useDispatch();

  const openedFilter = useSelector(selectOpenedFilter);

  const [isOpen, setIsOpen] = useState(false);

  const handleOpen = useEventCallback(() => {
    dispatch(setOpenedFilter(filterKey));

    setIsOpen(true);
  });

  const handleClose = useEventCallback(() => {
    if (openedFilter === filterKey) {
      dispatch(setOpenedFilter(undefined));
    }

    setIsOpen(false);
  });

  const handleClick = useCallback(() => {
    if (isOpen) {
      handleClose();
    } else {
      handleOpen();
    }
  }, [handleClose, handleOpen, isOpen]);

  const tooltipOpened = useMetaTooltip({ filterKey });

  useEffect(() => {
    if (isOpen && !openedFilter) {
      setIsOpen(false);
    }
  }, [handleClose, isOpen, openedFilter]);

  return { filterRef, onClick: handleClick, tooltipOpened, onClose: handleClose, isOpen };
};
